import { AsyncStatus } from 'lib-shared-legacy-types';
import { useCallback, useEffect, useState } from 'react';


import { bansApi } from './api';
import { UserActiveBan } from './types';

export type UseUserBanActionReturn = {
  bans: UserActiveBan[];
  refreshItems: () => void;
  asyncStatus: AsyncStatus;
};

export function useUserActiveBans(userId?: string): UseUserBanActionReturn {
  const [bans, setBans] = useState<UserActiveBan[]>([]);
  const [asyncStatus, setAsyncStatus] = useState<AsyncStatus>('succeeded');

  const getBanStatus = useCallback(async () => {
    if (!userId) {
      return;
    }
    setAsyncStatus('loading');

    try {
      const banStatus = await bansApi.getUserBan(userId);
      setBans(banStatus.data.bans);
      setAsyncStatus('succeeded');
    } catch {
      setAsyncStatus('failed');
    }
  }, [userId]);

  useEffect(() => {
    getBanStatus();
  }, [getBanStatus]);

  return { bans, refreshItems: getBanStatus, asyncStatus };
}
